import { app } from '../../../../app';
import { Controller } from './license-violations.controller';

app.component('licenseViolations', {
    bindings:{
        licenseDetails: '<',
    },
    controller: Controller,
    templateUrl: require('./license-violations.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/license-management/license-violations/license-violations.component.js